(function () {
  'use strict';

  /* @ngdoc object
   * @name events.guests.list
   * @description
   *
   */
  angular
    .module('events.guests.list', [
      'ui.router'
    ]);
}());
